angular.module('impactx.manualordercreation').controller('ManualOrderCreationCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'ToolbarService',
    'BackService',
    'ToastService',
    'TranslationService',
    ManualOrderCreationCtrl]);

function ManualOrderCreationCtrl($scope, dataGen, $routeParams, ToolbarService, BackService, ToastService, TranslationService)
{
    var self = this;
    self.errorList = [];

    $scope.maxDate = new Date();

    dataGen.getData($scope, {comId: $routeParams.comId, usrId: $routeParams.usrId, cscId: $routeParams.cscId},
        "/purchaseorder/manualordercreation").then(function () {
        defineButtons();
        self.checkForErrors();
    });

    self.updateGUI = function (index) {
        if (index !== undefined) {
            var item = $scope.data.items[index];
            if (!item.hasValues) {
                item.hasValues = true;
                $scope.data.items.push(JSON.parse(JSON.stringify($scope.data.templateItem)));
                self.checkForErrors();
            }
        }
    };

    self.removeLine = function (index) {
        $scope.data.items.splice(index, 1);
        self.checkForErrors();
    };

    self.save = function () {
        return dataGen.postAsForm($scope, {data: $scope.data}, "/purchaseorder/manualordercreation/save").then(function () {
            BackService.back();
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
        });
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: TranslationService.get('save'),
                action: self.save,
                type: 'validation',
                params: {
                    form: $scope.dialogData,
                    disableExpressions: {valueFunction: hasErrors, errorsFunction: getErrors}
                }
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    self.checkForErrors = function () {
        self.errorList.length = 0;
        if ($scope.data.bookBudget) {
            if (!$scope.data.bookBudget.setId) {
                self.errorList.push($scope.trns.fillBookBudget);
            }
        }
        if ($scope.data.promotionalOrder) {
            if (!$scope.data.promotionalOrder.setId) {
                self.errorList.push($scope.trns.fillPromotionalOrder);
            }
        }
        if ($scope.data.items.length === 1) {
            self.errorList.push($scope.trns.noPositions);
        }
    };

    function hasErrors() {
        return self.errorList.length;
    }

    function getErrors() {
        return self.errorList;
    }

    self.getTaxRates = function (index) {
        var orderDate = $scope.data.orderDate;
        if (index !== undefined && index >= 0 &&
            $scope.data.items[index].deliveryDate.dateValue) {
            orderDate = $scope.data.items[index].deliveryDate
        }
        var params = {
            taxDate: orderDate,
            orderUserId: impactX.isDefined($scope, 'data.user.selected.id') || 0,
            cscId: impactX.isDefined($scope, 'data.contract.selected.id') || 0
        };
        dataGen.postAsForm({}, params, '/purchaseorder/manualordercreation/taxrates').then(function (data) {
            if (data && data.data && data.data.entries) {
                if (index !== undefined && index >= 0) {
                    updateItemTax($scope.data.items[index], data.data.entries);
                }
                else {
                    for (var i=0; i<$scope.data.items.length; i++) {
                        var item = $scope.data.items[i];
                        if (!item.deliveryDate.dateValue) {
                            updateItemTax(item, data.data.entries);
                        }
                    }
                }
            }
        });
    };

    function updateItemTax(item, entries) {
        item.price.taxRate.entries = entries;
        var selected = item.price.taxRate.selected;
        if (selected) {
            var isValid = entries.filter(function (entry) {
                return entry.id === selected.id;
            }).length > 0;
            if (!isValid) {
                delete item.price.taxRate.selected;
            }
        }
    }
}